module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921045334_T.7f94e6df.jpg";